import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { addAccountAPI, deleteAccountAPI, getAccountAPI, getAccountDetailAPI, updateAccountAPI } from './api';
import {
  filterAccount,
  filterAccountSuccess,
  filterAccountFailure,
  getDetailAccountById,
  getDetailAccountByIdSuccess,
  getDetailAccountByIdFailure,
  registerAccountSuccess,
  registerAccountFailure,
  registerAccount,
  updateAccountSuccess,
  updateAccountFailure,
  deleteAccountSuccess,
  deleteAccountFailure,
  updateAccount,
  deleteAccount,
} from './slice';
import {
  SearchEntityMasterRequest,
  DetailEntityMasterRequest,
  UpdateEntityMasterRequest,
  DeleteEntityMasterRequest,
} from 'api-types/src/types/entity-master';

function* fetchAccountMaster({ payload }: { payload: SearchEntityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAccountAPI, trimQueryData(payload));
    yield put(filterAccountSuccess(response.data));
  } catch (error) {
    yield put(filterAccountFailure());
  }
}

function* fetchAccountDetail({ payload }: { payload: DetailEntityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAccountDetailAPI, payload);
    yield put(getDetailAccountByIdSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailAccountByIdFailure({ message: error?.message }));
  }
}

function* registerAccountSaga({ payload }: { payload: UpdateEntityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addAccountAPI, payload);
    yield put(registerAccountSuccess(response));
  } catch (error: any) {
    yield put(registerAccountFailure({ message: error?.message }));
  }
}

function* updateAccountSaga({ payload }: { payload: UpdateEntityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(updateAccountAPI, payload);
    yield put(updateAccountSuccess(response));
  } catch (error: any) {
    yield put(updateAccountFailure({ message: error?.message }));
  }
}

function* deleteAccountSaga({ payload }: { payload: DeleteEntityMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(deleteAccountAPI, payload);
    yield put(deleteAccountSuccess(response));
  } catch (error: any) {
    yield put(deleteAccountFailure({ message: error?.message }));
  }
}

function* watchAccountMaster() {
  yield takeLatest(filterAccount, fetchAccountMaster);
  yield takeLatest(getDetailAccountById, fetchAccountDetail);
  yield takeLatest(registerAccount, registerAccountSaga);
  yield takeLatest(updateAccount, updateAccountSaga);
  yield takeLatest(deleteAccount, deleteAccountSaga);
}

export default watchAccountMaster;
